import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames,
  getSubscriptionPlansAPI,
  addSubscriptionPlanAPI,
  updateSubscriptionPlanAPI,
  deleteSubscriptionPlanAPI,
  activateDeactivateSubscriptionPlanAPI,
  getSubscriptionPlanByIdAPI,
  getSubscriptionPlanFeaturesAPI,
  getSubscriptionPlanTagsAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Subscription Table Column Names
export const fetchSubscriptionPlanTableColumns = createAsyncThunk(
  "subscriptionPlan/fetchSubscriptionPlanTableColumns",
  async (subscription, thunkAPI) => {
    try {
      const response = await getTableColumnNames(subscription);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Subscription
export const fetchAllSubscriptionPlans = createAsyncThunk(
  "subscriptionPlan/fetchSubscriptionPlans",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionPlansAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription plans");
    }
  }
);

// Add Subscription
export const addSubscriptionPlan = createAsyncThunk(
  "subscriptionPlan/addSubscriptionPlan",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await addSubscriptionPlanAPI(subscription);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding subscription plan");
    }
  }
);

// Update Subscription
export const updateSubscriptionPlan = createAsyncThunk(
  "subscriptionPlan/updateSubscriptionPlan",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await updateSubscriptionPlanAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating subscription plan");
    }
  }
);

// Delete Subscription
export const deleteSubscriptionPlan = createAsyncThunk(
  "subscriptionPlan/deleteSubscriptionPlan",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await deleteSubscriptionPlanAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting subscription plan");
    }
  }
);

// Active Deactive Subscription
export const activateDeactivateSubscriptionPlan = createAsyncThunk(
  "subscriptionPlan/activateDeactivateSubscriptionPlan",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateSubscriptionPlanAPI(subscription);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating subscription plan");
    }
  }
);

// Fetch Features
export const fetchSubscriptionPlanById = createAsyncThunk(
  "subscriptionPlan/fetchSubscriptionPlanById",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionPlanByIdAPI(subscription);      
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription plan");
    }
  }
);

export const fetchSubscriptionPlanFeatures = createAsyncThunk(
  "subscriptionPlanModule/fetchSubscriptionPlanFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionPlanFeaturesAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription plan modules");
    }
  }
);

export const fetchSubscriptionPlanTags = createAsyncThunk(
  "subscriptionPlanModule/fetchSubscriptionPlanTags",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionPlanTagsAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription plan modules");
    }
  }
);